import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter, map } from 'rxjs/operators';
var RoutingService = /** @class */ (function () {
    function RoutingService(_router, _activatedRoute) {
        this._router = _router;
        this._activatedRoute = _activatedRoute;
    }
    Object.defineProperty(RoutingService.prototype, "routes", {
        get: function () {
            var _this = this;
            return this._router.events
                .pipe(filter(function (event) { return event instanceof NavigationEnd; }), map(function () { return _this._activatedRoute; }), map(function (route) {
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route;
            }), filter(function (route) { return route.outlet === 'primary'; }));
        },
        enumerable: true,
        configurable: true
    });
    return RoutingService;
}());
export { RoutingService };
